<template>
	<div class="navbg" ref="navbg">
		<audio ref="audioPlayer1" src="../../static/buyer.mp3"></audio>
		<audio ref="audioPlayer2" src="../../static/seller.mp3"></audio>
		<div :class="isFixed ? 'fixed': ''">
			<div :class=" missionshow ?'mynav mynav1':'mynav'">
				<div class="l_s">
					<div class="logo" @click="$router.push('/home')">
						<img src="../assets/image/logo.png">
					</div>
					<div class="search" v-if="!notsearch">
						<el-input v-model="search" ref="input" :placeholder="select == 1?'请输入产品名、货号、品牌等':'请输入渠道名'"
							@keyup.enter.native="onsearch()" @focus="searchshow = true" @blur="outsearchshow" class="input-with-select">
							<el-select v-model="select" slot="prepend" v-if="searchtype">
								<el-option label="商品" :value="1"></el-option>
								<el-option label="渠道" :value="2"></el-option>
							</el-select>
						</el-input>
						<el-button type="primary" class="search-btn" @click="onsearch()">
							搜索
						</el-button>
						<div class="selectdiv" v-if="searchshow" @mouseover="onin" @mouseleave="onout"
							@click="onselected">
							<div class="st">
								<span>最近搜索</span>
								<i class="el-icon-delete" @click="onqk"></i>
							</div>
							<div class="jl" v-for="(v,k) in searchlist" :key="k" @click="onjl(v)" v-if="k<7">{{v}}</div>
						</div>
					</div>
				</div>
				<div class="operation" v-if="loginshow && missionshow">
					<el-tooltip class="item" effect="dark" placement="bottom">
						<div slot="content">
							余额:{{appdata.myinfo.money}}
							<span class="green" @click="$router.push('/buyer/topUp')">去充值</span>
						</div>
						<div class="idiv" @click="$router.push('/buyer/topUp')">
							<i class="el-icon-coin i"></i>
							<span>余额</span>
						</div>
					</el-tooltip>
					<div class="idiv">
						<el-badge :value="count" :max="99" :hidden="count == 0">
							<i class="el-icon-bell i" @click="ondrawer"></i>
						</el-badge>
						<span>通知</span>
					</div>
					<div class="idiv">
						<i class="el-icon-postcard i" @click="onsizelist"></i>
						<span>尺码表</span>
					</div>
					<div class="idiv">
						<i class="el-icon-download i" @click="ondownload"></i>
						<span>操作手册</span>
					</div>
					<!-- {{bnid}}
					{{snid}}
					<span @click="aa">删除</span> -->
				</div>
			</div>
		</div>
		<el-drawer :visible.sync="drawer" direction="rtl" :before-close="handleClose" size="900px" :show-close="false">
			<div class="tabdiv" slot="title">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane :name="v.ctype.toString()" v-for="(v,k) in msg" :key="k">
						<span slot="label">
							{{v.ctype_name}}
							<el-badge v-if="v.un_read_num>0" :value="v.un_read_num" :max="99"></el-badge>
						</span>
					</el-tab-pane>
				</el-tabs>
			</div>

			<div class="msg-toolbar">
				<el-button size="small" :disabled="currentTabUnread() <= 0" :loading="msgActing" @click="onMarkTabRead">全部已读</el-button>
				<el-button size="small" type="danger" plain :disabled="!list.length" :loading="msgActing" @click="onDeletePage">删除本页</el-button>
			</div>
			<div class="tablediv">
				<el-table :data="list" style="width: 100%" border>
					<el-table-column prop="title" label="标题" align="center" header-align="center" width="150px">
					</el-table-column>
					<el-table-column prop="content" label="内容" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="是否已读" align="center" header-align="center" width="80px">
						<template slot-scope="scope">
							{{scope.row.is_read == 0?'未读':'已读'}}
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center"
						width="160px">
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" width="90px">
						<template slot-scope="scope">
							<div class="cz">
								<span @click="onjump(scope.row)">查看</span>
								<span @click="ondelete(scope.row)">删除</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</el-drawer>

		<el-dialog title="尺码表" :visible.sync="show" width="720px" :before-close="onclose">
			<div class="s_search">
				<el-input v-model="sval" placeholder="搜索品牌" size="small"></el-input>
			</div>
			<div class="sizediv">
				<div class="item"
					v-if="v.name.indexOf(sval.toLowerCase())!=-1 || v.name.indexOf(sval.toUpperCase())!=-1 || v.name_en.indexOf(sval.toLowerCase())!=-1|| v.name_en.indexOf(sval.toUpperCase())!=-1"
					@click="onimgdrawer(v.pics)" v-for="(v,k) in appdata.list.product_size_standard_list" :key="k">
					<img :src="v.icon">
					<span>{{v.name}}</span>
					<span>{{v.name_en}}</span>
				</div>
			</div>
		</el-dialog>
		<el-drawer :visible.sync="imgdrawer" direction="rtl" :before-close="imgClose" size="700px" :show-close="false">
			<div class="imgarrdiv">
				<el-image class="img" :src="v" :preview-src-list="imgarr" v-for="(v,k) in imgarr" :key="k">
				</el-image>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		name: 'mynav',
		data() {
			return {
				search: "",
				isFixed: false,
				missionshow: false,
				searchshow: false,
				searchlist: [],
				cshow: false,
				loginshow: false,
				timer: null,
				drawer: false,
				msg: [],
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				activeName: "",
				count: 0,
				bnid: "",
				snid: "",
				show: false,
				imgdrawer: false,
				imgarr: [],
				sval: "",
				select: 1,
				searchtype: false,
				msgActing: false,
			}
		},

		props: {
			notsearch: {
				type: Boolean,
				default: false
			},
		},

		inject: ['appdata', 'reload'],

		mounted() {
			if (this.$cookies.get('token')) {
				this.loginshow = true;
			}

			if (this.$route.path != '/detail') {
				window.addEventListener('scroll', this.handleScroll);
			}

			if (this.$route.path.indexOf("seller") != -1 || this.$route.path.indexOf("buyer") != -1) {
				this.missionshow = true;
			} else {
				this.missionshow = false;
			}

			if (this.$route.query.search) {
				this.search = this.$route.query.search;
			}

			if (window.localStorage.getItem('searchlist')) {
				this.searchlist = JSON.parse(window.localStorage.getItem('searchlist'));
			}

			if (window.localStorage.getItem('bnid')) {
				this.bnid = window.localStorage.getItem('bnid');
			} else {
				this.bnid = "";
				window.localStorage.setItem('bnid', this.bnid);
			}

			if (window.localStorage.getItem('snid')) {
				this.snid = window.localStorage.getItem('snid');
			} else {
				this.snid = "";
				window.localStorage.setItem('snid', this.snid);
			}

			if (this.$route.path.indexOf("buyer") != -1) {
				this.searchtype = true;
				this.onbuyer_msg();
				this.autoGet(1);
			}

			if (this.$route.path.indexOf("seller") != -1) {
				this.onseller_msg();
				this.autoGet(2);
			}
		},

		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
			clearInterval(this.times);
			this.timer = null;
		},

		methods: {
			onsearch() {
				this.searchshow = false;
				if (this.search) {
					if (this.searchlist.indexOf(this.search) != -1) {
						this.searchlist.splice(this.searchlist.indexOf(this.search), 1);
					}

					this.searchlist.unshift(this.search);
					window.localStorage.setItem('searchlist', JSON.stringify(this.searchlist));
				}
				if(this.$route.path.indexOf("buyer") != -1) {
					if(this.select == 1) {
						const route = this.$router.resolve({
							path: '/list',
							query: {
								search: this.search,
								category: this.$route.query.category,
							}
						});
						window.open(route.href, '_blank');
					} else {
						if (this.$route.path == "/buyer/shops") {
							if (this.$route.query.search != this.search) {
								this.$router.push({
									path: '/buyer/shops',
									query: {
										search: this.search,
									}
								})
							} else {
								this.$emit('onsearch', this.search)
							}
						} else {
							this.$router.push({
								path: '/buyer/shops',
								query: {
									search: this.search,
								}
							})
						}
					}
				} else {
					if (this.$route.path == "/list") {
						if (this.$route.query.search != this.search) {
							this.$router.replace({
								query: {
									search: this.search,
									category: this.$route.query.category,
								}
							})
						}
						this.$emit('onsearch', this.search)
					} else {
						this.$router.push({
							path: '/list',
							query: {
								search: this.search,
								category: this.$route.query.category,
							}
						})
					}
				}
			},

			handleScroll() {
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 获取滑动距离
				if (scrollTop < this.$refs.navbg.offsetTop) {
					this.isFixed = false;
				} else {
					this.isFixed = true; // 设置fixed定位
				}
			},

			onin() {
				this.cshow = true;
			},

			onout() {
				this.cshow = false;
			},

			outsearchshow() {
				if (!this.cshow) {
					this.searchshow = false;
				}
			},

			onselected() {
				this.$refs.input.focus();
			},

			onjl(val) {
				this.search = val;
				this.onsearch();
			},

			onqk() {
				this.searchlist = [];
				window.localStorage.setItem('searchlist', JSON.stringify(this.searchlist));
			},

			ondrawer() {
				if (this.$route.path.indexOf("buyer") != -1) {
					this.onmsg(1);
				}

				if (this.$route.path.indexOf("seller") != -1) {
					this.onmsg(2);
				}
			},

			handleClose() {
				this.drawer = false;
			},

			autoGet(n) {
				this.times = setInterval(() => {
					if (n == 1) {
						this.onbuyer_msg();
					}

					if (n == 2) {
						this.onseller_msg();
					}
				}, 10000);
			},

			onmsg(n) {
				if (n == 1) {
					this.$axios.get('/api/user/buyer_group_msg').then(res => {
						if (res.data.code == 0) {
							this.msg = res.data.data.list;
							this.activeName = '1';
							this.drawer = true;
							this.onbuyer_msg_val();
						}
					}).catch(err => {
						console.log(err)
					})
				}

				if (n == 2) {
					this.$axios.get('/api/user/seller_group_msg').then(res => {
						if (res.data.code == 0) {
							this.msg = res.data.data.list;
							this.activeName = '11';
							this.drawer = true;
							this.onseller_msg_val();
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},

			handleClick(val) {
				this.page = 1;
				this.pageSize = 20;
				this.total = 0;
				if (this.$route.path.indexOf("buyer") != -1) {
					this.onbuyer_msg_val();
				}

				if (this.$route.path.indexOf("seller") != -1) {
					this.onseller_msg_val();
				}

			},

			onbuyer_msg() {
				this.$axios.get('/api/user/buyer_msg').then(res => {
					if (res.data.code == 0) {
						this.count = res.data.data.unread_count;
						var arr = [];
						if (res.data.data.unread_count != 0) {
							if (this.bnid != res.data.data.list[0].id) {
								this.$refs.audioPlayer1.currentTime = 0;
								this.$refs.audioPlayer1.play();
								this.bnid = res.data.data.list[0].id;
								window.localStorage.setItem('bnid', this.bnid);
							}
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onseller_msg() {
				this.$axios.get('/api/user/seller_msg').then(res => {
					if (res.data.code == 0) {
						this.count = res.data.data.unread_count;
						var arr = [];
						if (res.data.data.unread_count != 0) {
							if (this.snid != res.data.data.list[0].id) {
								this.$refs.audioPlayer2.currentTime = 0;
								this.$refs.audioPlayer2.play();
								this.snid = res.data.data.list[0].id;
								window.localStorage.setItem('snid', this.snid);
							}
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},

			handleCurrentChange() {
				if (this.$route.path.indexOf("buyer") != -1) {
					this.onbuyer_msg_val();
				}

				if (this.$route.path.indexOf("seller") != -1) {
					this.onseller_msg_val();
				}
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				if (this.$route.path.indexOf("buyer") != -1) {
					this.onbuyer_msg_val();
				}

				if (this.$route.path.indexOf("seller") != -1) {
					this.onseller_msg_val();
				}
			},

			onbuyer_msg_val() {
				var obj = {};
				obj.ctype = this.activeName;
				obj.page = this.page;
				obj.limit = this.pageSize;
				this.$axios.post('/api/user/buyer_msg', obj).then(res => {
					if (res.data.code == 0) {
						this.list = res.data.data.list;
						this.total = res.data.data.count;
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onseller_msg_val() {
				var obj = {};
				obj.ctype = this.activeName;
				obj.page = this.page;
				obj.limit = this.pageSize;
				this.$axios.post('/api/user/seller_msg', obj).then(res => {
					if (res.data.code == 0) {
						this.list = res.data.data.list;
						this.total = res.data.data.count;
					}
				}).catch(err => {
					console.log(err)
				})
			},

			isBuyerSide() {
				return this.$route.path.indexOf("buyer") != -1
			},
			currentTabUnread() {
				var name = this.activeName
				var tab = (this.msg || []).find(function(v) {
					return String(v.ctype) === String(name)
				})
				return tab ? Number(tab.un_read_num || 0) : 0
			},
			currentTabName() {
				var name = this.activeName
				var tab = (this.msg || []).find(function(v) {
					return String(v.ctype) === String(name)
				})
				return tab ? (tab.ctype_name || '') : ''
			},
			msgApiError(res) {
				return (res && res.data && (res.data.msg || res.data.message)) || '操作失败'
			},
			unreadDoneText(res) {
				var n = res && res.data && res.data.data && res.data.data.updated
				if (n == null || n === '' || isNaN(Number(n))) {
					return '已全部标为已读'
				}
				return Number(n) <= 0 ? '暂无未读' : ('已全部标为已读（' + Number(n) + ' 条）')
			},
			showUnreadDone(res) {
				var n = res && res.data && res.data.data && res.data.data.updated
				if (n != null && n !== '' && !isNaN(Number(n)) && Number(n) <= 0) {
					this.$message.info('暂无未读')
					return
				}
				this.$message.success(this.unreadDoneText(res))
			},
			reloadMsgSurface() {
				if (this.isBuyerSide()) {
					this.onbuyer_msg()
					this.$axios.get('/api/user/buyer_group_msg').then(res => {
						if (res.data.code == 0) {
							this.msg = res.data.data.list || []
						}
						this.onbuyer_msg_val()
					}).catch(err => {
						console.log(err)
						this.onbuyer_msg_val()
					})
				} else {
					this.onseller_msg()
					this.$axios.get('/api/user/seller_group_msg').then(res => {
						if (res.data.code == 0) {
							this.msg = res.data.data.list || []
						}
						this.onseller_msg_val()
					}).catch(err => {
						console.log(err)
						this.onseller_msg_val()
					})
				}
			},
			onMarkTabRead() {
				var unread = this.currentTabUnread()
				if (unread <= 0) {
					this.$message.warning('当前分类没有未读消息')
					return
				}
				var name = this.currentTabName() || '当前分类'
				this.$confirm('将「' + name + '」' + unread + ' 条未读标为已读，消息不会删除。', '全部已读', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.clearUnreadByCtype(unread)
				}).catch(() => {})
			},
			clearUnreadByCtype(unread) {
				var clearUrl = this.isBuyerSide() ? '/api/user/buyer_msg_clear_unread' : '/api/user/seller_msg_clear_unread'
				this.msgActing = true
				this.$axios.post(clearUrl, {
					ctype: this.activeName
				}).then(res => {
					if (res.data.code == 0) {
						this.msgActing = false
						this.showUnreadDone(res)
						this.reloadMsgSurface()
					} else {
						this.markTabReadByIds(unread, clearUrl)
					}
				}).catch(err => {
					this.msgActing = false
					console.log(err)
				})
			},
			markTabReadByIds(unread, clearUrl) {
				var listUrl = this.isBuyerSide() ? '/api/user/buyer_msg' : '/api/user/seller_msg'
				var limit = Math.max(Number(this.total || 0), Number(unread || 0), Number(this.pageSize || 20))
				this.$axios.post(listUrl, {
					ctype: this.activeName,
					page: 1,
					limit: limit
				}).then(res => {
					if (res.data.code != 0) {
						this.msgActing = false
						this.$message.error(this.msgApiError(res))
						return
					}
					var rows = (res.data.data && res.data.data.list) || []
					var ids = rows.filter(function(row) {
						return Number(row.is_read) == 0
					}).map(function(row) {
						return row.id
					}).join(',')
					if (!ids) {
						this.msgActing = false
						this.$message.info('暂无未读')
						this.reloadMsgSurface()
						return
					}
					this.$axios.post(clearUrl, {
						ids: ids
					}).then(res2 => {
						this.msgActing = false
						if (res2.data.code == 0) {
							this.showUnreadDone(res2)
							this.reloadMsgSurface()
						} else {
							this.$message.error(this.msgApiError(res2))
						}
					}).catch(err => {
						this.msgActing = false
						console.log(err)
					})
				}).catch(err => {
					this.msgActing = false
					console.log(err)
				})
			},
			onDeletePage() {
				if (!this.list.length) {
					this.$message.warning('本页没有消息')
					return
				}
				var n = this.list.length
				this.$confirm('删除本页 ' + n + ' 条消息，不可恢复。是否继续？', '删除本页', {
					confirmButtonText: '确定删除',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					var ids = this.list.map(function(row) {
						return row.id
					}).join(',')
					var delUrl = this.isBuyerSide() ? 'api/user/buyer_msg_delete' : 'api/user/seller_msg_delete'
					this.msgActing = true
					this.$axios.post(delUrl, {
						ids: ids
					}).then(res => {
						this.msgActing = false
						if (res.data.code == 0) {
							this.$message.success('已删除本页 ' + n + ' 条消息')
							var remain = Number(this.total || 0) - n
							if (this.page > 1 && remain <= (this.page - 1) * this.pageSize) {
								this.page = this.page - 1
							}
							this.reloadMsgSurface()
						} else {
							this.$message.error(this.msgApiError(res))
						}
					}).catch(err => {
						this.msgActing = false
						console.log(err)
					})
				}).catch(() => {})
			},

			onjump(o) {
				if (o.is_read == 0) {
					var obj = {
						ids: o.id
					};

					if (this.$route.path.indexOf("buyer") != -1) {
						this.$axios.post('/api/user/buyer_msg_clear_unread', obj).then(res => {
							if (res.data.code == 0) {
								this.onjump1(o);
							}
						}).catch(err => {
							console.log(err)
						})
					}

					if (this.$route.path.indexOf("seller") != -1) {
						this.$axios.post('/api/user/seller_msg_clear_unread', obj).then(res => {
							if (res.data.code == 0) {
								this.onjump1(o);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				} else {
					this.onjump1(o);
				}
			},

			onjump1(o) {
				if (this.$route.fullPath != o.url) {
					this.onbuyer_msg();
					this.$router.push(o.url);
					this.drawer = false;
					this.msg = [];
					this.list = [];
					this.page = 1;
					this.pageSize = 20;
					this.total = 0;
					this.activeName = "";
				} else {
					this.$message({
						showClose: true,
						message: '已在该页面',
						type: 'warning'
					});
				}
			},

			ondelete(o) {
				this.$confirm("是否删除该条数据, 是否继续?", '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						ids: o.id
					}
					if (this.isBuyerSide()) {
						this.$axios.post('api/user/buyer_msg_delete', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('删除成功');
								this.reloadMsgSurface();
							} else {
								this.$message.error(this.msgApiError(res));
							}
						}).catch(err => {
							console.log(err)
						})
					}

					if (!this.isBuyerSide() && this.$route.path.indexOf("seller") != -1) {
						this.$axios.post('api/user/seller_msg_delete', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('删除成功');
								this.reloadMsgSurface();
							} else {
								this.$message.error(this.msgApiError(res));
							}
						}).catch(err => {
							console.log(err)
						})
					}

				}).catch(() => {});
			},

			onsizelist() {
				this.show = true;
			},

			onclose() {
				this.show = false;
			},

			onimgdrawer(pics) {
				if (pics) {
					this.imgarr = pics.split(',');
				}
				this.imgdrawer = true;
			},

			imgClose() {
				this.imgdrawer = false;
				this.imgarr = [];
			},

			aa() {
				window.localStorage.setItem('bnid', "");
				window.localStorage.setItem('snid', "");
				this.bnid = "";
				this.snid = "";
			},

			ondownload() {
				var url = "";
				if (this.$route.path.indexOf("buyer") != -1) {
					url = "https://oss.zhidayd.com/%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C-%E4%B9%B0%E5%AE%B6.docx"
				}

				if (this.$route.path.indexOf("seller") != -1) {
					url = "https://oss.zhidayd.com/%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C-%E5%8D%96%E5%AE%B6.docx"
				}

				window.open(url, '_blank');
			}
		}
	}
</script>

<style scoped lang="less">
	.navbg {
		width: 100%;
		background-color: #fff;
		// box-shadow: rgba(0,0,0,5%) 0px 2px 4px 0px;
		padding: 16px 0;
		height: 84px;
		box-sizing: border-box;
		min-width: 1200px;
	}

	.mynav {
		width: 1200px;
		margin: 4px auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.mynav1 {
		width: 100% !important;
		padding: 0 30px;
		box-sizing: border-box;
	}

	.l_s {
		display: flex;
		align-items: center;
	}


	.fixed {
		width: 100%;
		position: fixed;
		top: 0;
		background-color: #fff;
		z-index: 9;
		padding: 16px 0;
	}

	.logo {
		width: 168px;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.search {
		margin-left: 180px;
		position: relative;
		display: flex;
		align-items: center;
		border: 2px solid #ff4714;
		border-radius: 10px;
		height: 44px;
		width: 592px;
		padding-left: 4px;
		box-sizing: border-box;

		/deep/ .input-with-select {
			font-size: 12px;
			border-radius: 10px;
			padding-right: 90px;
		}
		
		/deep/ .input-with-select .el-input__inner {
			border-radius: 10px;
			border: none;
		}

		/deep/ .input-with-select .el-input-group__prepend {
			background-color: #fff;
		}
		
		/deep/ .input-with-select .el-select {
			width: 80px;
			border: none;
		}
		
		/deep/ .el-input-group__prepend{
			border: none;
			border-right: 1px solid #ff4714;
		}
		
		.search-btn {
			position: absolute;
			// top: 0;
			right: 4px;
			width: 72px;
			height: 36px;
			border-radius: 8px;
			font-size: 16px;
			font-weight: 600;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #ff4714;
			border-color: #ff4714;
		}

		.selectdiv {
			width: 592px;
			border: 1px solid #ff4714;
			border-radius: 6px;
			height: 350px;
			position: absolute;
			top: 45px;
			left: 0;
			background-color: #fff;
			z-index: 999;
			padding: 10px 12px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			align-items: flex-start;

			.st {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;

				span {
					color: #111;
					font-weight: bolder;
					font-size: 16px;
				}

				i {
					font-size: 18px;
					cursor: pointer;
				}
			}

			.jl {
				color: #666;
				margin-top: 20px;
				font-size: 14px;
				cursor: pointer;
			}
		}
	}

	.operation {
		display: flex;
		align-items: center;

		.i {
			font-size: 30px;
			color: #ff4714;
		}

		.idiv {
			width: 48px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin: 0 3px;
			cursor: pointer;

			span {
				font-size: 12px;
				color: #ff4714;
			}
		}
	}

	.sxi {
		margin-left: 6px;
		font-size: 14px;
		cursor: pointer;
	}

	/deep/ .el-drawer__header {
		margin-bottom: 0px;
	}

	.tablediv {
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.msg-toolbar {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 0 20px 12px;
		box-sizing: border-box;
	}

	.cz {
		span {
			color: #ff4714;
			cursor: pointer;
		}
	}

	.sizediv {
		width: 100%;
		display: flex;
		flex-wrap: wrap;

		.item {
			cursor: pointer;
			border: 1px solid transparent;
			height: 130px;
			width: 100px;
			margin: 0 5px 20px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			img {
				width: 80px;
				height: 80px;
			}

			span {
				margin-top: 3px;
				font-size: 12px;
				line-height: 16px;
				color: #666;
				text-align: center;
				word-break: break-all;
			}
		}

		.item:hover {
			border-radius: 10px;
			border-color: #e2e2e2;
			box-shadow: 0 0 14px 2px #f0f0f0;
		}
	}

	.imgarrdiv {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.img {
			width: 700px;
		}
	}

	.s_search {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-bottom: 30px;

		.el-input {
			width: 300px !important;
		}
	}

	.green {
		color: greenyellow;
		padding-left: 8px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/common/mynav.vue